// Ephemeral PR previews are served from Cloud Run tag URLs (`pr-<n>---<host>.a.run.app`). Those
// hosts can't be registered on the reCAPTCHA site key: `a.run.app` is a public suffix, and the tag
// host is a sibling of the service host rather than a subdomain. reCAPTCHA is therefore skipped on
// previews, and the back does the same for these origins — see previewEnv.ts in lidz_back.
const PREVIEW_HOST = /^pr-\d+---backoffice-front(?:-ephemeral)?-3mq2ziy2cq-uw\.a\.run\.app$/;

const isPreviewHost = (): boolean => PREVIEW_HOST.test(window.location.hostname);

export default isPreviewHost;
